<template>
  <div>

    <b-modal id="modal_pic_pedido" title="Selecione uma Promoção" ref="my-modal" size="lg" centered ok-title="Salvar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" @show="resetModal" @hidden="resetModal" @ok="handleOk"
      :ok-disabled="GET_LOADING || impostoLoading" :cancel-disabled="GET_LOADING || impostoLoading">
      <b-overlay variant="white" :show="GET_LOADING || impostoLoading" spinner-variant="primary" blur="0" opacity=".75"
        rounded="sm">
        <template #overlay v-if="GET_LOADING">
          <div class="text-center mt-5">
            <feather-icon icon="loader" class="font-large-2"></feather-icon>
            <p id="cancel-label" class="mt-1 font-weight-bolder">
              Aguarde, carregando promoções...
            </p>
          </div>
        </template>
        <template #overlay v-if="impostoLoading">
          <div class="text-center">
            <strong>Calculando impostos...</strong>
            <b-spinner small class="ml-1"></b-spinner>
          </div>
        </template>
        <b-tabs v-model="tabs" content-class="mt-2" justified>
          <b-tab active title="Promoções por cliente" :disabled="GET_LOADING">
            <div>
              <app-collapse accordion type="margin">
                <app-collapse-item v-for="item_cliente in GET_PIC.pic_cliente"
                  :title="formatDate(item_cliente.piciniciovalidade) + ' - ' + formatDate(item_cliente.picterminovalidade)"
                  :key="item_cliente.picid" :idCollapse="`pix-${item_cliente.picid}`" :pic-selected="item_cliente"
                  @check-pic="handleCheckPic($event.picSelected, $event.checked, 'pic_cliente')">
                  <div class="business-items" v-for="item_cliente_pic in item_cliente.ItemsPic">
                    <div class="business-item">
                      <div class="media-list media-bordered">
                        <b-media class="row justify-content-between align-items-center p-0">
                          <template #aside data-col="10">
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <b-checkbox v-if="item_cliente.RegraConsumo === 'QE'"
                                  :checked="item_cliente_pic.picid === picSelected.picid" disabled
                                  class="custom-control-primary mr-1"
                                  :id="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  :name="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  @change="handleCheckItemPic(item_cliente_pic, $event)" />
                                <b-checkbox v-else class="custom-control-primary mr-1"
                                  :id="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  :name="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  @change="handleCheckItemPic(item_cliente_pic, $event)" />
                                <b-img :src="item_cliente_pic.item_img_principal" blank-color="#ccc" width="64"
                                  alt="placeholder" style="margin-right: 10px;" />
                                <div>
                                  <h4 class="media-heading"> {{ item_cliente_pic.item_descricao }} -
                                    Cod.Ref.({{ item_cliente_pic.referencia }})</h4>
                                  <div class="d-flex align-items-center">
                                    <div class="font-weight-bolder text-success mr-2 d-flex align-items-center">
                                      <span id="R">R$</span><span class="font-weight-bolder display-4">{{
                                        item_cliente_pic.picitemvalorpic | formaPriceNotR$
                                      }}</span>
                                      <div class="font-weight-bolder text-secondary mr-1"
                                        style="text-decoration: line-through;padding-left: 5px">
                                        {{ item_cliente_pic.item_price | formtPriceBr }}
                                      </div>
                                      <b-badge variant="light-danger">
                                        -{{ item_cliente_pic.porcentagem_desconto }}%
                                      </b-badge>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </template>
                          <template #default class="d-flex justify-content-end">
                            <div class="item-quantity mt-auto d-flex justify-content-end align-items-center">
                              <span>Qtd: {{ item_cliente_pic.RegraConsumo }}</span>
                              <b-form-spinbutton size="sm" class="ml-75" inline
                                v-model="item_cliente_pic.picitemquantidade" min="1"
                                :max="item_cliente_pic.picitemquantidadesaldo" />
                            </div>
                          </template>
                        </b-media>
                      </div>
                    </div>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>
          </b-tab>
          <b-tab title="Promoções gerais" :disabled="GET_LOADING">
            <div>

              <app-collapse accordion type="margin">
                <app-collapse-item v-for="item_gerais in GET_PIC.pic_genericas"
                  :title="formatDate(item_gerais.piciniciovalidade) + ' - ' + formatDate(item_gerais.picterminovalidade)"
                  :key="item_gerais.picid" :pic-selected="item_gerais" :checked-pic="item_gerais.checked"
                  @check-pic="handleCheckPic($event.picSelected, $event.checked, 'pic_genericas')">

                  <div class="business-items" v-for="item_gerais_pic in item_gerais.ItemsPic">

                    <div class="business-item">
                      <div class="media-list media-bordered">
                        <b-media class="row justify-content-between align-items-center p-0">
                          <template #aside data-col="10">
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <b-checkbox v-if="item_gerais.RegraConsumo === 'QE'"
                                  :checked="item_gerais_pic.picid === picSelected.picid" disabled
                                  class="custom-control-primary mr-1"
                                  :id="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  :name="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  @change="handleCheckItemPic(item_gerais_pic, $event)" />
                                <b-checkbox v-else class="custom-control-primary mr-1"
                                  :id="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  :name="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  @change="handleCheckItemPic(item_gerais_pic, $event)" />
                                <b-img :src="item_gerais_pic.item_img_principal" blank-color="#ccc" width="64"
                                  alt="placeholder" style="margin-right: 10px;" />
                                <div>
                                  <h4 class="media-heading"> {{ item_gerais_pic.item_descricao }} -
                                    Cod.Ref.({{ item_gerais_pic.referencia }})</h4>
                                  <div class="d-flex align-items-center">
                                    <div class="font-weight-bolder text-success mr-2 d-flex align-items-center">
                                      <span id="R">R$</span><span class="font-weight-bolder display-4">{{
                                        item_gerais_pic.picitemvalorpic | formaPriceNotR$
                                      }}</span>
                                      <div class="font-weight-bolder text-secondary mr-1"
                                        style="text-decoration: line-through;padding-left: 5px">
                                        {{ item_gerais_pic.item_price | formtPriceBr }}
                                      </div>
                                      <b-badge variant="light-danger">
                                        -{{ item_gerais_pic.porcentagem_desconto }}%
                                      </b-badge>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </template>
                          <template #default class="d-flex justify-content-end">
                            <div class="item-quantity mt-auto d-flex justify-content-end align-items-center">
                              <span>Qtd: </span>
                              <b-form-spinbutton v-if="item_gerais.RegraConsumo === 'QE'" size="sm" class="ml-75" inline
                                v-model="item_gerais_pic.picitemquantidade"
                                :min="item_gerais_pic.picitemquantidadesaldo"
                                :max="item_gerais_pic.picitemquantidadesaldo" disabled />
                              <b-form-spinbutton v-else-if="item_gerais.RegraConsumo === 'CS'" size="sm" class="ml-75"
                                inline wrap v-model="item_gerais_pic.picitemquantidade"
                                :max="item_gerais_pic.picitemquantidadesaldo" />
                              <!--                              <b-form-spinbutton-->
                              <!--                                  v-else-->
                              <!--                                  size="sm"-->
                              <!--                                  class="ml-75"-->
                              <!--                                  :state="true"-->
                              <!--                                  inline-->
                              <!--                                  v-model="item_gerais_pic.picitemquantidade"-->
                              <!--                              />-->
                              <b-form-input v-else type="number" class="ml-75"
                                v-model="item_gerais_pic.picitemquantidade"
                                @blur="item_gerais_pic.picitemquantidade = $event.target.value > 0 ? $event.target.value : 1"
                                style="width: 90px;height: 30px" :min="1" />
                              <!--                              <b-input-->
                              <!--                                  v-else-->
                              <!--                                  type="number"-->
                              <!--                                  v-model="item_gerais_pic.picitemquantidade"-->
                              <!--                                  style="width: 110px;height: 35px"-->
                              <!--                              />-->
                            </div>
                          </template>
                        </b-media>
                      </div>
                    </div>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>

          </b-tab>
        </b-tabs>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BCol, BButton, BTabs, BTab, BCardText, BImg, BOverlay,
} from 'bootstrap-vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItemCheckbox.vue';
import { mapGetters } from 'vuex';
import { formaPriceNotR$, formtPriceBr } from '@core/utils/filter';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import axios from 'axios';
import Swal from 'sweetalert2';
import { getTotvsBaseUrl } from '@/utils/totvsApi';
import ItemStore from '../../store/item.store';

const picService = new SLSPicService();
export default {
  components: {
    BOverlay,
    BImg,
    BButton,
    BModal,
    BCol,
    BFormSelect,
    BTabs,
    BTab,
    BCardText,
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      operacaoData: null,
      tabs: 0,
      impostoLoading: false,
      picSelected: {
        picid: null,
        piciniciovalidade: null,
        picterminovalidade: null,
        picclienteid: null,
      },
      infoModal: {
        type: null,
        operacao: null,
        data: null,
      },
    };
  },
  filters: {
    formaPriceNotR$,
    formtPriceBr,
  },
  mounted() {
    this.initializeQuantities();
  },
  methods: {
    formatDate(date) {
      // console.log('Date:', date); // Debugging line
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    initializeQuantities() {
      this.GET_PIC.pic_genericas.forEach((item_gerais) => {
        if (item_gerais.RegraConsumo === 'CS') {
          item_gerais.ItemsPic.forEach((item) => {
            item.picitemquantidade = item.picitemquantidadesaldo;
          });
        }
      });
    },
    handleCheckPic(picSelected, isSelectd, type) {
      switch (this.infoModal.type) {
        case 'info-pedido':
          this.$store.commit('PicStore/SET_CHECKED_PICK_INFO_PEDIDO', {
            picid: picSelected.picid,
            checked: isSelectd,
            type,
          });
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_INFO_PEDIDO', {
            itemid: this.$store.getters['PicStore/GET_PIC_SELECTED'].ItemsPic[0].itemid,
            checked: true,
          });
          const picChecked = this.$store.getters['PicStore/GET_PIC_SELECTED'];
          this.$store.commit('PicStore/REMOVER_ITEM_PIC_INFO_PEDIDO', {
            picid: picChecked.picid,
            itemid: picChecked.ItemsPic[0].itemid,
          });
          if (isSelectd) {
            this.$store.commit('PicStore/ADD_UPDATE_INFO_PEDIDO_PIC', picChecked);
          } else {
            this.$store.commit('PicStore/REMOVER_EXITENTE_INFO_PEDIDO_PIC', picChecked.picid);
          }
          break;
        case 'operacao-pedido':
          this.$store.commit('PicStore/SET_CHECKED_PICK_OPERACAO_PEDIDO', {
            picid: picSelected.picid,
            checked: isSelectd,
            type,
          });
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_OPERACAO_PEDIDO', {
            itemid: this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'].ItemsPic[0].itemid,
            checked: true,
          });
          const picCheckedOperacao = this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'];
          this.$store.commit('PicStore/REMOVER_ITEM_PIC_OPERACAO_PEDIDO', {
            picid: picCheckedOperacao.picid,
            itemid: picCheckedOperacao.ItemsPic[0].itemid,
          });
          if (isSelectd) {
            this.$store.commit('PicStore/ADD_UPDATE_OPERACAO_PEDIDO_PIC', picCheckedOperacao);
          } else {
            this.$store.commit('PicStore/REMOVER_EXITENTE_OPERACAO_PEDIDO_PIC', picCheckedOperacao.picid);
          }
          break;
      }
    },
    handleCheckItemPic(itemPicSelected, isSelectd) {
      // console.log('itemPicSelected', itemPicSelected)
      // console.log('isSelectd', isSelectd)
      document.querySelector(`#check-item-${itemPicSelected.itemid}-${itemPicSelected.picid}`).checked = isSelectd;
      switch (this.infoModal.type) {
        case 'info-pedido':
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_INFO_PEDIDO', {
            itemid: itemPicSelected.itemid,
            checked: isSelectd,
          });
          isSelectd ? this.$store.commit('PicStore/ADD_UPDATE_ITEMS_PIC_INFO_PEDIDO', itemPicSelected) : this.$store.commit('PicStore/REMOVER_ITEM_PIC_INFO_PEDIDO', {
            picid: itemPicSelected.picid,
            itemid: itemPicSelected.itemid,
          });
          break;
        case 'operacao-pedido':
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_OPERACAO_PEDIDO', {
            itemid: itemPicSelected.itemid,
            checked: isSelectd,
          });
          isSelectd ? this.$store.commit('PicStore/ADD_UPDATE_ITEMS_PIC_OPERACAO_PEDIDO', itemPicSelected) : this.$store.commit('PicStore/REMOVER_EXITENTE_OPERACAO_PEDIDO_PIC', {
            picid: itemPicSelected.picid,
            itemid: itemPicSelected.itemid,
          });
          break;
      }
    },
    showModal(data) {
      this.infoModal = data;

      if (data.type === 'operacao-pedido') {
        this.operacaoData = data.data;
      }

      this.$bvModal.show('modal_pic_pedido');
      this.$nextTick(async () => {
        await picService.getPicPedidos()
          .then(() => {
            if (this.GET_PIC.pic_cliente.length > 0) {
              this.tabs = 0;
              return;
            }
            if (this.GET_PIC.pic_genericas.length > 0) {
              this.tabs = 1;
            }
          })
          .finally(() => {
            switch (this.infoModal.type) {
              case 'info-pedido':
                if (this.$store.getters['PicStore/GET_PIC_SELECTED'].picid) {
                  this.$store.dispatch('PicStore/checkedPicSelected');
                }
                break;
              case 'operacao-pedido':
                if (this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'].picid) {
                  this.$store.dispatch('PicStore/checkedPicSelectedOperacao');
                }
                break;
            }
          });
      });
    },
    async resetModal() {
      // console.log('resete-modal')
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.savePic();
      this.handleSubmit();
      // console.log('ITEM CLIENTE', this.GET_PIC)
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
    async savePic() {
      switch (this.infoModal.type) {
        case 'info-pedido':
          await this.extrairItensPicInfoPedido();
          break;
        case 'operacao-pedido':
          await this.extrairItensPic();
          break;
      }
    },
    resolverTamanhoCor(tamanho) {
      switch (tamanho) {
        case 'Pequeno':
          return 'p';
        case 'Medio':
          return 'm';
        case 'Grande':
          return 'g';
        case 'Extra Grande':
          return 'xg';
        default:
          return 'p';
      }
    },
    async extrairItensPic() {
      if (this.GET_PIC_SELECTED_OPERACAO.ItemsPic && this.GET_PIC_SELECTED_OPERACAO.ItemsPic.length > 0) {
        // console.log('ENTREI ID EXTRAIR ITENS PIC')
        const itemPicSelectedOperacao = this.GET_PIC_SELECTED_OPERACAO.RegraConsumo === 'QE' ? this.GET_PIC_SELECTED_OPERACAO.ItemsPic : this.GET_PIC_SELECTED_OPERACAO.ItemsPic.filter((item) => item.checked);

        const impostosCalculados = await this.calcularImpostosParaItensPic(itemPicSelectedOperacao);

        let pedidosAgrupados = [];
        // console.log('itemPicSelectedOperacao', itemPicSelectedOperacao)
        itemPicSelectedOperacao.forEach((item) => {
          const impostoItem = impostosCalculados.find((imp) => imp.itemid === item.itemid);
          const marca = item.cod_marca;
          const { referencia } = item;
          const Qtde = 0;
          const ValorTotal = 0;

          // console.log(pedidosAgrupados, 'pedidosAgrupados')

          const pedidoExistente = pedidosAgrupados.find((pedido) => pedido.CodMarca === marca && pedido.CodReferencia === referencia);

          // console.log('pedidoExistente', pedidoExistente)

          if (!pedidoExistente) {
            const novoItem = {
              codMarca: item.cod_marca,
              familiaComercialId: item.referencia,
              cdncor: item.cdn_cor,
              cdn_embalagem: item.cdn_embalagem,
              des_cor: item.des_cor,
              cdn_tamanho: item.cdn_tamanho,
              itemId: item.itemid,
              item_descricao: item.item_descricao,
              pedidoItemQuantidade: item.picitemquantidade,
              marca: item.des_marca,
              embalagem: item.des_embalag,
              precoUnitario: item.picitemvalorpic,
              valorTotal: +parseInt(item.picitemquantidade) * parseFloat(item.picitemvalorpic),
              pedidoItemQuantidadeSaldo: item.picitemquantidadesaldo,
              pedidoItemQuantidadeFaturada: '-',
              pedido_item_seq: item.picitemsequencia,
              des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
              referencia: item.referencia,
              des_referencia: item.des_referencia,
              cod_categ: item.cod_categ,
              picid: item.picid,
              regra_pic: this.GET_PIC_SELECTED_OPERACAO.RegraConsumo,
              saldo: item.picitemquantidadesaldo || 0,
              valor_total: Number(item.picitemvalorpic) * Number(item.picitemquantidade),
              precoComImposto: impostoItem?.precoComImposto || 0,
              valorTotalComImposto: impostoItem?.precoComImposto * item.picitemquantidade || 0,
              baseIcms: impostoItem?.baseIcms || 0,
              valorIcms: impostoItem?.valorIcms || 0,
              naturezaoperacaoidimposto: impostoItem?.naturezaoperacaoidimposto || 0,
              base_icms: impostoItem?.baseIcms || 0,
              valor_icms: impostoItem?.valorIcms || 0,
              natureza_operacao_id_imposto: impostoItem?.naturezaoperacaoidimposto || 0,
            };
            const novoPedido = {
              CodMarca: marca,
              DescricaoMarca: item.des_marca,
              CodReferencia: referencia,
              DescricaoReferencia: item.des_referencia,
              CodEmbalagem: item.cdn_embalagem,
              DescricaoEmbalagem: item.des_embalag,
              Qtde,
              PrecoUnitario: item.picitemvalorpic,
              ValorTotal,
              referencia: `${item.referencia} - ${item.des_referencia}`,
              tipoPedido: 'pic',
              picid: item.picid,
              itens: [],
              editar: {
                cod_marca: marca,
                cod_categ: item.cod_categ,
                cod_referencia: item.referencia,
                cod_embalagem: item.cdn_embalagem,
                precoId: item.picid,
              },
            };
            novoPedido.itens.push(novoItem);
            pedidosAgrupados.push(novoPedido);
          } else {
            // console.log('JA EXISTE')
            const novoItem = {
              codMarca: item.cod_marca,
              familiaComercialId: item.referencia,
              cdncor: item.cdn_cor,
              cdn_embalagem: item.cdn_embalagem,
              des_cor: item.des_cor,
              cdn_tamanho: item.cdn_tamanho,
              itemId: item.itemid,
              item_descricao: item.item_descricao,
              pedidoItemQuantidade: item.picitemquantidade,
              marca: item.des_marca,
              embalagem: item.des_embalag,
              precoUnitario: item.picitemvalorpic,
              valorTotal: +parseInt(item.picitemquantidade) * parseFloat(item.picitemvalorpic),
              pedidoItemQuantidadeSaldo: item.picitemquantidadesaldo,
              pedidoItemQuantidadeFaturada: null,
              pedidoitemseq: item.picitemsequencia,
              des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
              referencia: item.referencia,
              des_referencia: item.des_referencia,
              cod_categ: item.cod_categ,
              picid: item.picid,
              regra_pic: this.GET_PIC_SELECTED_OPERACAO.RegraConsumo,
              precoComImposto: impostoItem?.precoComImposto || 0,
              valorTotalComImposto: impostoItem?.precoComImposto * item.picitemquantidade || 0,
              baseIcms: impostoItem?.baseIcms || 0,
              valorIcms: impostoItem?.valorIcms || 0,
              naturezaoperacaoidimposto: impostoItem?.naturezaoperacaoidimposto || 0,
              base_icms: impostoItem?.baseIcms || 0,
              valor_icms: impostoItem?.valorIcms || 0,
              natureza_operacao_id_imposto: impostoItem?.naturezaoperacaoidimposto || 0,
            };
            pedidoExistente.itens.push(novoItem);
            pedidoExistente.Qtde += item.picitemquantidade;
            pedidoExistente.PrecoUnitario += item.picitemvalorpic;
            pedidoExistente.ValorTotal += item.picitemtotalmercadoria;
          }
        });

        pedidosAgrupados = pedidosAgrupados.map((pedido) => {
          const Qtde = pedido.itens.reduce((acc, item) => acc + item.pedidoItemQuantidade, 0);
          const ValorTotal = pedido.itens.reduce((acc, item) => acc + (item.pedidoItemQuantidade * item.precoUnitario), 0);
          // console.log('ValorTotal', ValorTotal)
          pedido.ValorTotal = ValorTotal;
          pedido.Qtde = Qtde;
          return pedido;
        });
        // console.log('pedidosAgrupados', pedidosAgrupados)
        this.$store.dispatch('intensPedido/set_tabela_itens_pic', pedidosAgrupados);
        return pedidosAgrupados;
      }
    },

    async extrairItensPicInfoPedido() {
      this.$store.commit('PedidosStore/REMOVER_ITEM_PIC_PROMOCAO');

      if (this.GET_PIC_SELECTED.ItemsPic && this.GET_PIC_SELECTED.ItemsPic.length > 0) {
        const itemPicSelected = this.GET_PIC_SELECTED.RegraConsumo === 'QE'
          ? this.GET_PIC_SELECTED.ItemsPic
          : this.GET_PIC_SELECTED.ItemsPic.filter((item) => item.checked);

        const impostosCalculados = await this.calcularImpostosParaItensPic(itemPicSelected);

        itemPicSelected.forEach((item) => {
          const impostoItem = impostosCalculados.find((imp) => imp.itemid === item.itemid);

          const novoItem = {
            cdn_cor: item.cdn_cor,
            cdn_embalag: item.cdn_embalagem,
            cdn_tamanho: item.cdn_tamanho,
            cod_marca: item.cod_marca,
            des_cor: item.des_cor,
            des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
            embalagem: item.des_embalag,
            familia_comercial_descricao: item.des_referencia,
            familia_comercial_id: item.referencia,
            index: this.$store.getters['PedidosStore/getItemPedido'].length,
            item_descricao: item.item_descricao,
            item_id: item.itemid,
            item_imagem: item.item_img_principal,
            marca: item.des_marca,
            pedido_item_preco_unitario: item.picitemvalorpic,
            pedido_item_quantidade: item.picitemquantidade,
            pedido_item_seq: item.picitemsequencia,
            pic_id: item.picid,
            item_pic_promocao: true,
            regra_pic: this.GET_PIC_SELECTED.RegraConsumo,
            saldo: item.picitemquantidadesaldo || 0,
            valor_total: Number(item.picitemvalorpic) * Number(item.picitemquantidade),
            precoComImposto: impostoItem?.precoComImposto || 0,
            valorTotalComImposto: impostoItem?.precoComImposto * item.picitemquantidade || 0,
            base_icms: impostoItem?.baseIcms || 0,
            valor_icms: impostoItem?.valorIcms || 0,
            natureza_operacao_id_imposto: impostoItem?.naturezaoperacaoidimposto || 0,
          };

          this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', novoItem);
        });
      }
    },
    async calcularImpostosParaItensPic(itemsPic) {
      try {
        this.impostoLoading = true;
        const resultados = [];

        const clienteData = this.infoModal.type === 'info-pedido'
          ? this.GET_CLIENTE_DATA
          : this.operacaoData;

        const capaPedidoData = this.infoModal.type === 'info-pedido'
          ? this.GET_DATA_CAPA_PEDIDO
          : this.operacaoData;

        const baseUrl = await getTotvsBaseUrl();
        const promessas = itemsPic.map(async (item) => {
          // console.log('ITEM', item)
          try {
            const data = {
              ttCabPedido: [{
                'c-pr-cod-estabel': clienteData.estabelecimento.estabelecimentoid,
                'c-pr-nome-abrev': clienteData.cliente.clientenomeabreviado,
                'c-pr-nat-operacao': clienteData.naturezaOperacao?.naturezaoperacaoid || '6101',
                'c-pr-cod-canal-venda': clienteData.canalVenda?.canal_venda_id || '',
                'c-pr-it-codigo': item.itemid,
                'd-pr-quantidade': item.picitemquantidade,
                'd-pr-vl-preori-ped': item.picitemvalorpic,
                'd-pr-per-des-item': item.porcentagem_desconto,
                'p-simulacao': 0,
                'p-uf-ds': clienteData.enderecoEntrega.ufid,
                'p-cidade-ds': clienteData.enderecoEntrega.clienteenderecocidade,
                'p-contr-icms': capaPedidoData.clienteisentoie ? 1 : 0,
                'p-tp-frete': 0,
                'p-tp-tabpre': capaPedidoData.tabelaprecoid,
                'p-cod-cond-pagto': capaPedidoData.condicaopagamentoid,
                ttitempedido: [{
                  itCodigo: item.itemid,
                }],
              }],
            };

            const url = `${baseUrl}/simular-Impostos-novo-metodo`;

            const response = await axios.post(url, data, {
              headers: {
                'Content-Type': 'application/json',
              },
            });

            if (response.data.ttRetornoImposto && response.data.ttRetornoImposto[0]) {
              return {
                itemid: item.itemid,
                precoComImposto: response.data.ttRetornoImposto[0]['d-pr-unitario'] || 0,
                baseIcms: response.data.ttRetornoImposto[0]['d-pr-base-icms'] || 0,
                valorIcms: response.data.ttRetornoImposto[0]['d-pr-valor-icms'] || 0,
                naturezaoperacaoidimposto: response.data.ttRetornoImposto[0]['c-pr-nat-operacao'] || 0,
              };
            }

            return null;
          } catch (error) {
            console.error(`Erro ao calcular imposto para item ${item.itemid}:`, error);
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: 'Erro ao calcular impostos',
              timer: 2000,
            });
            return null;
          }
        });

        const resultadosProcessados = await Promise.all(promessas);
        return resultadosProcessados;
      } catch (error) {
        console.error('Erro geral ao calcular impostos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
        return null;
      } finally {
        this.impostoLoading = false;
      }
    },
  },
  computed: {
    ItemStore() {
      return ItemStore;
    },
    ...mapGetters('PicStore', ['GET_PIC', 'GET_LOADING', 'GET_OPERACAO_PEDIDO_PIC', 'GET_INFO_PEDIDO_PIC', 'GET_PIC_SELECTED', 'GET_PIC_SELECTED_OPERACAO']),
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    descricaoPicSelecte() {
      return this.picSelected.picid ? this.picSelected.picdescricao : 'Selecione uma promoção';
    },
  },

  created() {
    this.$root.$on('openModal:pic', this.showModal);
  },
  destroyed() {
    this.$root.$off('openModal:pic', this.showModal);
  },
};
</script>
<style lang="scss" scoped>
.custom-control-primary {
  position: relative;
  top: -10px;
  left: 10px;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-container input[type="checkbox"] {
  margin-right: 10px;
}

.R {
  font-size: 2rem;
}

.price {
  text-decoration: line-through;
}
</style>
